<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ 'users.title' | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="creation-form">
      <button *ngIf="!isCreationMode" (click)="onEdit()" [matTooltip]="'users.list.add' | translate" mat-mini-fab
        class="action-button" color="primary">
        <mat-icon aria-label="Add">person_add</mat-icon>
      </button>
      <app-user-edit *ngIf="isCreationMode && !editedId" (editFinished)="onEditFinished()"></app-user-edit>
    </section>


    <form [formGroup]="filterForm" style="display: flex">
      <app-autocomplete *ngIf="!isLoadingFilterForm" [valueWanted]="'name'" [control]="filterForm.get('client')"
        [list]="clients" (changeEvent)="onFilter()" label="users.filter.client">
      </app-autocomplete>

      <mat-checkbox formControlName="includeDeleted" (click)="onFilter()" color="primary">
        Afficher les utilisateurs désactivés
      </mat-checkbox>

      <button style="margin-left: 15px" mat-icon-button color="primary" matTooltip="Effacer les filtres"
        (click)="clearFilters()">
        <mat-icon>
          clear
        </mat-icon>
      </button>
    </form>

    <mat-form-field class="filterField">
      <mat-label>Filtrer</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Votre filtre (hors agences et donneurs d'ordre)"
        #input>
    </mat-form-field>

    <section class="datatable-wrapper">
      <div class="datatable-container">
        <app-displayed-columns-menu [columnsParams]="columnsParams"
          (onMooveColumnsOrderEvent)="onMooveColumnsOrder($event)"
          (onSelectColumnVisibilityEvent)="onSelectColumnVisibility($event)"></app-displayed-columns-menu>

        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChanged($event)"
          multiTemplateDataRows>
          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.list.username' | translate }} </th>
            <td mat-cell *matCellDef="let user"> {{ user.username }} </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.list.email' | translate }} </th>
            <td mat-cell *matCellDef="let user"> {{ user.email }} </td>
          </ng-container>

          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.list.role' | translate }} </th>
            <td mat-cell *matCellDef="let user"> {{ user.role.description }} </td>
          </ng-container>

          <ng-container matColumnDef="clients">
            <th mat-header-cell *matHeaderCellDef> {{ 'users.list.clients' | translate }} </th>
            <td mat-cell *matCellDef="let user">
              <ul>
                <li *ngFor="let client of user.clients"> {{ client.name }} </li>
              </ul>
            </td>
          </ng-container>

          <ng-container matColumnDef="sites">
            <th mat-header-cell *matHeaderCellDef> {{ 'users.list.sites' | translate }} </th>
            <td mat-cell *matCellDef="let user">
              <span *ngIf="user.allSites">Tous</span>
              <ul *ngIf="!user.allSites">
                <li *ngFor="let site of user.sites"> {{ site.name }} </li>
              </ul>
            </td>
          </ng-container>

          <ng-container matColumnDef="features">
            <th mat-header-cell *matHeaderCellDef> {{ 'users.list.features' | translate }}
            </th>
            <td mat-cell *matCellDef="let user">
              <ul *ngIf="user?.features?.length > 0">
                <li *ngFor="let feature of user.features">{{feature.name}}</li>
              </ul>
              <ng-container *ngIf="user?.features.length === 0">
                De son Agence
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.list.createdBy' | translate }} </th>
            <td mat-cell *matCellDef="let user"> {{ user.createdBy?.username }} </td>
          </ng-container>

          <ng-container matColumnDef="createdOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.list.createdOn' | translate }} </th>
            <td mat-cell *matCellDef="let user"> {{ user.createdOn | amDateFormat : "DD/MM/YYYY HH:mm" }} </td>
          </ng-container>

          <ng-container matColumnDef="lastLoginOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.list.lastLoginOn' | translate }} </th>
            <td mat-cell *matCellDef="let user"> {{ user.lastLoginOn | amDateFormat : "DD/MM/YYYY HH:mm" }} </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="actions"> {{ 'users.list.actions' | translate }} </th>
            <td mat-cell *matCellDef="let user">

              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menu boutons" color="primary"
                *ngIf="user.id !== editedId">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <button mat-menu-item class="action-button" [disabled]="isLoading" (click)="onEdit(user.id)">
                  <mat-icon aria-label="Edit" color="primary">edit</mat-icon>
                  <span>{{'users.list.edit' | translate}}</span>
                </button>

                <button mat-menu-item class="action-button" *ngIf="user.isActive" [disabled]="isLoading"
                  (click)="onChangeState(user, false)">
                  <mat-icon aria-label="Disable" color="primary">toggle_on</mat-icon>
                  <span>{{'users.list.disable' | translate}}</span>
                </button>

                <button mat-menu-item class="action-button" color="accent" *ngIf="!user.isActive" [disabled]="isLoading"
                  (click)="onChangeState(user, true)">
                  <mat-icon aria-label="Disable" color="primary">toggle_off</mat-icon>
                  <span>{{'users.list.enable' | translate}}</span>
                </button>

                <button mat-menu-item class="action-button" *ngIf="user.lastLogonOn == null" [disabled]="isLoading"
                  (click)="onSendMail(user)">
                  <mat-icon aria-label="Edit" color="primary">email</mat-icon>
                  <span>{{'users.list.sendWelcome' | translate}}</span>
                </button>

                <button mat-menu-item class="action-button" [disabled]="isLoading" (click)="onSendApkMail(user)">
                  <mat-icon aria-label="Edit" color="primary">send</mat-icon>
                  <span>Envoyer l'appli par mail</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let user" [attr.colspan]="displayedColumns.length">
              <div *ngIf="user.id === editedId" class="row-edit"
                [@detailExpand]="user.id === editedId ? 'expanded' : 'collapsed'">
                <app-user-edit [user]="user" (editFinished)="onEditFinished()"></app-user-edit>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <!-- <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr> -->
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row" [ngClass]="{
                            'disabled': !row.isActive,
                            'user-expanded-row': row.id === editedId
                        }"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
        </table>

        <mat-paginator *ngIf="pagination" [pageSize]="pagination.pageSize" [length]="pagination.totalRecords"
          [pageIndex]="pagination.pageNumber - 1" (page)="onPageChanged($event)" showFirstLastButtons></mat-paginator>
      </div>

    </section>
    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
  </mat-card-content>
</mat-card>
